/**
 * Public configuration for the practitioner signup flow.
 *
 * Only public Supabase values belong here.
 * Never put Supabase service_role or Stripe secret keys here.
 */

type EnvRecord = Record<string, string | undefined>

const env: EnvRecord =
  (
    import.meta as unknown as {
      env?: EnvRecord
    }
  ).env ?? {}

const supabaseUrl = (env.VITE_SUPABASE_URL ?? '').trim()

const supabaseAnonKey = (env.VITE_SUPABASE_ANON_KEY ?? '').trim()

const createAccountFunction =
  (env.VITE_SUPABASE_FN_CREATE_PRACTITIONER ?? '').trim() ||
  'create-practitioner-account'

const checkoutFunction =
  (env.VITE_SUPABASE_FN_PRACTITIONER_CHECKOUT ?? '').trim() ||
  'create-practitioner-subscription'

export const integrationConfig = {
  supabaseUrl,
  supabaseAnonKey,
  createAccountFunction,
  checkoutFunction,
  termsOfServiceUrl: '/terms-of-service',
} as const

export const passwordMinLength = 8

export const practitionerRoutes = {
  landing: '/practitioners',
  join: '/practitioners/join',
  membership: '/practitioners/membership',
  welcome: '/practitioners/welcome',
} as const

export const stripeCheckoutOrigin = 'https://checkout.stripe.com'

function isPrivilegedKey(key: string): boolean {
  if (key.startsWith('sb_secret_')) {
    return true
  }

  const parts = key.split('.')

  if (parts.length < 2) {
    return false
  }

  try {
    const payload = parts[1]
      .replace(/-/g, '+')
      .replace(/_/g, '/')

    const decoded = JSON.parse(atob(payload)) as {
      role?: string
    }

    return decoded.role === 'service_role'
  } catch {
    return false
  }
}

export function isBackendConfigured(): boolean {
  return Boolean(
    integrationConfig.supabaseUrl &&
      integrationConfig.supabaseAnonKey &&
      !isPrivilegedKey(integrationConfig.supabaseAnonKey)
  )
}